import { z } from 'zod';

import { t } from '../i18n/validation.js';

export const loginSchema = z.object({
  username: z.string().trim().min(1, t('validation.login.usernameRequired')),
  password: z.string().min(1, t('validation.login.passwordRequired')),
});

export type LoginFormValues = z.infer<typeof loginSchema>;
